type PersonWithAvatar = Readonly<{
  avatar?: { url: string } | null;
}>;

/**
 * Extracts the avatar image URL from a Person's `avatar` field.
 * Works with the main GraphQL schema where `Person.avatar` is a `Photo` with a direct `url`.
 */
export const getAvatarUrl = (person: PersonWithAvatar | null | undefined): string | undefined => {
  return person?.avatar?.url || undefined;
};
